import React from 'react';

import { CustomSVGProps } from '@cineamo/ui/src/icons/CustomSVGProps.types';

export function IconAppStore24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="App Store">
            <path
                d="M20.9138 8.18149C20.1292 8.66164 19.4793 9.33303 19.0248 10.1328C18.5704 10.9326 18.3264 11.8346 18.3155 12.7544C18.3186 13.7896 18.6253 14.8011 19.1976 15.6637C19.77 16.5263 20.5827 17.2021 21.5353 17.6073C21.1598 18.819 20.6039 19.9673 19.8865 21.0136C18.86 22.4912 17.7867 23.9688 16.1536 23.9688C14.5204 23.9688 14.1004 23.02 12.2183 23.02C10.3828 23.02 9.72971 24 8.23695 24C6.74418 24 5.70191 22.6312 4.50427 20.9514C2.9221 18.5982 2.05256 15.8384 2 13.0032C2 8.33674 5.03309 5.86388 8.01939 5.86388C9.606 5.86388 10.9279 6.90602 11.9232 6.90602C12.872 6.90602 14.3497 5.8017 16.154 5.8017C17.0817 5.77769 18.001 5.98219 18.8311 6.39719C19.6611 6.81219 20.3763 7.42495 20.9138 8.18149ZM12.048 5.53723C11.9384 5.5369 11.829 5.52651 11.7213 5.5062C11.6909 5.36297 11.6753 5.217 11.6746 5.07058C11.7266 3.86678 12.1937 2.71811 12.9968 1.8198C13.8981 0.784521 15.1614 0.133393 16.5275 0C16.56 0.158633 16.5756 0.320247 16.5742 0.482161C16.5445 1.71003 16.0943 2.89051 15.2987 3.82627C14.9011 4.3169 14.4079 4.72157 13.8491 5.0157C13.2903 5.30982 12.6775 5.48726 12.048 5.53723Z"
                fill={props.fill || 'black'}
            />
        </svg>
    );
}
